import * as React from 'react';
import Plyr from "plyr-react";
import "plyr-react/plyr.css";

import './AudioPlayer.scss';
import { useMemo } from 'react';
export interface IAudioPlayerProps {
    audioPlyrProps: any,
}

export function AudioPlayer({ audioPlyrProps }: IAudioPlayerProps) {



    const myMemo = useMemo(() => {
        return <Plyr {...audioPlyrProps} />
    }, [])

    return (
        <div className="w-full z-50 overflow-visible audio_player">
            {myMemo}
        </div>
    );
}
